import React from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Header({ address=-1 , title }) {
    const navigate = useNavigate();
  return (
    <>
      <div className="flex items-center pt-8 px-5 mb-3">
        {/* Back Button */}
        <button className="text-gray-600" onClick={()=> navigate(address)}>
          <ChevronLeft className="h-6 w-6" />
        </button>

        {/* Form Title */}
        <h1 className="text-gray-800 text-base font-bold font-poppins flex-grow text-center ">
          {title}
        </h1>
      </div>
    </>
  );
}
